import api from "shared/api";
import { baseApiService } from "shared/api";
import useSWRImmutable from "swr/immutable";

export const userFetcher = (url) => api.get(url).then((res) => res.data.data);

export function useUser({ triggerRequest = true } = {}) {
  return useSWRImmutable(
    triggerRequest ? baseApiService.ENDPOINTS.user.profile : null,
    userFetcher
  );
}
